import {
  INotificationCategory,
  INotificationItem,
  NotificationStatus,
  NotificationStatusType,
} from '@coherence-design-system/notification-center';
import { ILegacyNotification } from '../models/ILegacyNotification';
import { convertHtmlToText } from '.';
import { ActionButton } from '../components/molecules/ActionButton';
import { getIcon } from '.';
import { TeachingBubbleCategory, FreCategory } from './NotificationConstants';

export interface IExtendedNotificationItem extends INotificationItem {
  tag?: string;
}
export const transformNotifications = (
  notifications: ILegacyNotification[],
  updateNotificationStatus: {
    (itemKey: string, displayStatus: NotificationStatusType, readStatus?: string): void;
  }
) => {
  const categories: INotificationCategory[] = [];
  notifications
    .filter((item) => !item.tag?.startsWith(TeachingBubbleCategory)) // do not show items under teaching bubble category
    .filter((item) => !item.tag?.startsWith(FreCategory)) // do not show items under FRE category
    .forEach((item) => {
      const categoryKey = `${item.category.toLowerCase()}`;

      if (!categories[categoryKey]) {
        categories[categoryKey] = {
          itemKey: categoryKey,
          title: item.category,
          items: [],
          maxItemsCollapsed: 5,
          isExpanded: false,
          showCounter: true,
        };
      }
      const descriptionText = convertHtmlToText(item.htmlMessage)[0];
      const notificationItem: IExtendedNotificationItem = {
        itemKey: `${item.id}`,
        title: item.title,
        description: descriptionText,
        notificationStatus: NotificationStatus.READ,
        iconProps: getIcon(item.type),
        timestamp: new Date(item.startDate),
        timeFormatter: 'M/D/YY',
        isExpandable: descriptionText.toString().length > 100,
        links: item.referenceLink
          ? [{ children: 'Link', href: item.referenceLink, target: '_blank' }]
          : [],
        action: {
          actionButton: (
            <ActionButton
              onClick={() => updateNotificationStatus(`${item.id}`, NotificationStatus.DELETED)}
            />
          ),
          alwaysShow: false,
        },
        tag: item.tag,
      };
      categories[categoryKey].items.push(notificationItem);
    });

  return Object.values(categories) as INotificationCategory[];
};
